var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7643 7.67119L16.9258 3.12305V6.47082C16.9258 7.13583 17.4953 7.67119 18.2028 7.67119H21.7643Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8756 1.9043H3.89418C3.18673 1.9043 2.61719 2.43966 2.61719 3.10467V25.2601C2.61719 25.9251 3.18673 26.4605 3.89418 26.4605H19.437C20.1445 26.4605 20.714 25.9251 20.714 25.2601V6.45244",
    fill: "#E2E2E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0709 0.875H3.0895C2.38204 0.875 1.8125 1.41037 1.8125 2.07537V24.2308C1.8125 24.8958 2.38204 25.4312 3.0895 25.4312H18.6324C19.3398 25.4312 19.9094 24.8958 19.9094 24.2308V5.42315",
    fill: "#18A05E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0709 0.875H3.0895C2.38204 0.875 1.8125 1.41037 1.8125 2.07537V24.2308C1.8125 24.8958 2.38204 25.4312 3.0895 25.4312H18.6324C19.3398 25.4312 19.9094 24.8958 19.9094 24.2308V5.42315",
    stroke: "#18A05E",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9088 5.42315L15.0703 0.875V4.22277C15.0703 4.88778 15.6399 5.42315 16.3473 5.42315H19.9088Z",
    fill: "#8DD0AF",
    stroke: "#8DD0AF",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1503_10776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.49609,
    y: 10.8438,
    width: 13.0696,
    height: 11.2995,
    rx: 1.3125,
    stroke: "white",
    strokeWidth: 0.875
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64844 14.5008H17.2183",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64844 18.5398H17.2183",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83812 11.707V22.1968",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4241 11.6934V22.1832",
    stroke: "white",
    strokeWidth: 0.875,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1503_10776",
    x: 0.121094,
    y: 9.53125,
    width: 21.8203,
    height: 20.0488,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.0625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.96875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.392157 0 0 0 0 0.392157 0 0 0 0.0901961 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1503_10776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1503_10776",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxIcon);
export default __webpack_public_path__ + "static/media/xlsxIcon.3d7c8c00e75a4819246d4525219c06fd.svg";
export { ForwardRef as ReactComponent };